export const odluka_nagrade = {
    templateId: 38.1,
    category: 4,
    templateTitle: 'Odluka - nagrade za radne rezultate, dodatna plaća, dodatak uz mjesečnu plaću i sl..',
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) neoporezivo isplatiti radniku nagrade za radne rezultate, dodatnu plaća, dodatak uz mjesečnu plaću i sl., pri čemu je navedena isplata neoporeziva do iznosa od najviše ukupno 7.500,00 kn godišnje.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke se ubrajaju i nagrade za radne rezultate te drugi oblici dodatnog nagrađivanja radnika (dodatna plaća, dodatak uz mjesečnu plaću i slično).</p>
    <p>Navedeni primici smatraju se materijalnim pravima radnika, a koja nisu izravno propisana  Zakonom o radu, nego se po potrebi uređuju kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Međutim, ukoliko navedena prava nisu propisana pravilnikom o radu ili  kolektivnim ugovorom odnosno ako nisu određena ugovorom o radu, onda poslodavac samostalno odlučuje hoće li navedena pravo omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Novčane nagrade za radne rezultate i drugi oblici dodatnog nagrađivanja radnika su izuzete od ovrhe (do propisanih iznosa do kojih se ne smatraju oporezivim primitkom) te se u slučaju blokade računa radnika uplaćuju na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).
    <p>Također, nagrade za radne rezultate te drugi oblici dodatnog nagrađivanja radnika za poslodavca su porezno priznati trošak s aspekta utvrđivanja osnovice poreza na dobit, no samo ako ne prelaze ukupan iznos od 7.500,00 kn godišnje, po radniku.</p>
    <p>I radnik s nepunim radnim vremenom može ostvariti puni iznos neoprezive isplate nagrade za radne rezultate i druge oblike dodatnog nagrađivanja radnika, bez obzira na sate rada, ako je tako ugovoreno.</p>
    <p>Ukoliko se nagrade za radne rezultate te drugi oblici dodatnog nagrađivanja radnika isplaćuju radniku koji radi istovremeno kod dva ili više poslodavaca u poreznom razdoblju za koje se prigodna nagrada isplaćuje i/ili je tijekom poreznog razdoblja imao zasnovan radni odnos kod dva ili više poslodavaca, ali ne istodobno, radnik je obvezan prije isplate prigodne nagrade svakom poslodavcu podnijeti pisanu izjavu u kojoj će navesti je li kod drugog i/ili bivšeg poslodavca ostvario isplatu prigodne nagrade za to porezno razdoblje, u kojem iznosu i je li po toj osnovi obračunan i uplaćen predujam poreza na dohodak. Primjer takve izjave radnika možete vidjeti i izraditi <a class="local-link" href="/contract?template=38.2">ovdje</a>.</p>
    <p>U slučaju da je prigodna nagrada već isplaćena tijekom godine kod drugog poslodavca, neoporezivo se može isplatiti samo razlika do 7.500,00 kuna.</p>
    <p>Važno je naglasiti da je Pravilnikom o porezu na dohodak izričito propisano da se <strong> nagrade za radne rezultate te drugi oblici dodatnog nagrađivanja radnika (dodatna plaća, dodatak uz mjesečnu plaću i sl.) ne mogu isplatiti u gotovu novcu.</strong></p>
    <h5><strong>SVRHA DOKUMENTA</strong></h5>
    <p>Svrha nagrada za radne rezultate te drugih oblika dodatnog nagrađivanja radnika (dodatna plaća, dodatak uz mjesečnu plaću i sl.) je nagrađivanje radnika.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],


    headline: 'donosi sljedeću',
    title: ' ODLUKU ',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata nagrade za radne rezultate radnicima, prema odredbama Pravilnika o porezu na dohodak koji regulira neoporezive isplate, u vrijednosti'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata dodatne plaće radnicima, prema odredbama Pravilnika o porezu na dohodak koji regulira neoporezive isplate, u vrijednosti'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata dodatka uz mjesečnu plaću radnicima, prema odredbama Pravilnika o porezu na dohodak koji regulira neoporezive isplate, u vrijednosti'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn.'}]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom određuje se isplata' },
                                {type: 'input', value: '', required: true, help: "Unesite podatak o tome da li se radi o nagradi za radne rezultate, dodatnoj plaći ili o dodatku uz mjesečnu plaću, ili nečemu sličnom." },
                                { type: "text", content: "radniku," },
                                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'iz',},
                                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                                { type: 'text', content: ',' },
                                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'OIB:' },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: ', (u daljnjem tekstu: Radnik)'
                                },
                                {type: 'text', content: 'u vrijednosti'},
                                {type: 'input', value: '', required: true},]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Nagrada za radne rezultate iz ove Odluke isplaćuje se u roku od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana od dana donošenja ove Odluke.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Dodatna plaća iz ove Odluke isplaćuje se zajedno s isplatom plaće za mjesec'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: ','},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.'},]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Dodatak uz mjesečnu plaću iz ove Odluke isplaćuje se uz plaću, u budućem periodu od '},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'mjeseci, počevši od isplate plaće za'},
                                {type: 'input', value: '', required: true},]
                                
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {

                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'input', value: '', required: true, help: "Unesite podatak o tome da li se radi o nagradi za radne rezultate, dodatnoj plaći ili o dodatku uz mjesečnu plaću"},
                        {type: 'text', content: 'iz ove Odluke Poslodavac će isplatiti na tekući račun Radnika.'},
                    ],
                    value: '',
                }, 
            ],
        },
    
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Da bi radnici koji su radili kod dva ili više poslodavaca u poreznom razdoblju za koje se primici isplaćuju ili koji su tijekom poreznog razdoblja imali zasnovan radni odnos kod dva ili više poslodavaca, ostvarili pravo na nagradu iz ove odluke, dužni su prije isplate primitaka poslodavcu podnijeti pisanu izjavu u kojoj će navesti jesu li kod drugog i/ili bivšeg poslodavca ostvario isplatu tih primitaka za poreznom razdoblju i u kojem iznosu.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ukoliko postoji zakonska mogućnost korištenja neoporezive isplate, pri isplati prigodne nagrade koristiti će se ta porezna mogućnost.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Kadrovska služba \r\n2) Obračun plaća \r\n\r\nObavijest o odluci: Oglasna ploča.',
                    help: 'Po želji, slobodno izmijenite/obrišite predložene unose odnosno dopišite istima željene podatke.'
                }
            ]
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/38.1_odluka_nagrade.ts